import { QueryResult, useQuery } from '@apollo/client'
import { EvaluationFromLastTwoAppraisalsQuery, EvaluationFromLastTwoAppraisalsQueryVariables } from '../../../types'
import { SCORE_GRIDS_OVERVIEW_QUERY } from '../Queries'

export const useScoreGridsOverview = (
  employeeId: number,
): QueryResult<EvaluationFromLastTwoAppraisalsQuery, EvaluationFromLastTwoAppraisalsQueryVariables> => {
  return useQuery<EvaluationFromLastTwoAppraisalsQuery, EvaluationFromLastTwoAppraisalsQueryVariables>(SCORE_GRIDS_OVERVIEW_QUERY, {
    variables: { employeeId },
    fetchPolicy: 'network-only',
  })
}
